import React, { useState } from 'react';

import { H4 } from '../texts';
import { AccordionElement } from './accordion-element';
import { Styled } from './styled';

export const Accordion = (props) => {
  const { title, content, isBlocksOpen, Icon } = props;
  const [openBlocks, setOpenBlocks] = useState(
    isBlocksOpen ? content.map((_, index) => index) : []
  );
  return (
    <>
      {content.length ? (
        <Styled.Container>
          {title && <H4 color="mainFont">{title}</H4>}
          {content.map((el, index) => (
            <AccordionElement
              key={el.title}
              index={index}
              element={el}
              openBlocks={openBlocks}
              setOpenBlocks={setOpenBlocks}
              Icon={Icon}
            />
          ))}
        </Styled.Container>
      ) : null}
    </>
  );
};
